export const UserConsentModule = {
    namespaced: true,
    state: {
        advertisement: false,
        analytics: false
    },
    mutations: {
        SET_ADVERTISEMENT(state, value) {
            state.advertisement = value
        },
        SET_ANALYTICS(state, value) {
            state.analytics = value
        }
    },
    // Actions are functions that you call through your application that call mutations.
    actions: {
        /**
         * Get the initial of new test or the last state of ongoing test for the user
         * This should run once, when initialise app, so has to be synchronous (return promise)
         * @param commit
         * @param rootState
         * @returns {Promise<void>}
         */
        consentAdvertisement({commit}, value) {
            commit("SET_ADVERTISEMENT", value)
        },
        consentAnalytics({commit}, value) {
            commit("SET_ANALYTICS", value)
        },
    },
    getters: {
        getAdvertisement(state, getters, rootState) {
            return state.advertisement;
        },
        getAnalytics(state) {
            return state.analytics;
        }
    },

    // Modulising stores - spreading stores into different files
    modules: {}
}